export { FormattedContent } from './FormattedContent'
